import './back-to-top.css';
export default {
  "backToTop": "pf-v5-c-back-to-top",
  "button": "pf-v5-c-button",
  "modifiers": {
    "hidden": "pf-m-hidden"
  }
};